import React from "react";
import styles from "../CSS/Head.module.css";

const SocialHead = () => {
  return (
    <>
      <div className={styles.MainConatiner}>
        <div className={styles.Left}>
          <button className={styles.backButton}>
            <img
              src="https://cdn-icons-png.flaticon.com/128/271/271220.png"
              alt=""
            />
          </button>
        </div>
        <div className={styles.Right}>
          <img
            className={styles.UserPicture}
            src="https://cdn-icons-png.flaticon.com/128/1177/1177568.png"
            alt=""
          />
        </div>
      </div>
    </>
  );
};

export default SocialHead;
